/**
 * Lead-gate form: first screen of the chat widget. The visitor must leave
 * WhatsApp + email before any chat happens so the seller can always recontact.
 * Controlled by the parent widget — this component only renders the fields.
 */
import { WhatsappLogo, EnvelopeSimple, ShieldCheck } from "@phosphor-icons/react";

export function LeadGateForm({
  businessName,
  name,
  setName,
  phone,
  setPhone,
  email,
  setEmail,
  gateError,
  gateBusy,
  onSubmit,
}) {
  return (
    <form
      onSubmit={onSubmit}
      noValidate
      className="flex-1 p-4 flex flex-col gap-3 overflow-y-auto"
      data-testid="chat-lead-gate"
    >
      <div>
        <div className="text-base font-bold text-ink mb-1 h-display">
          ¿Empezamos?
        </div>
        <p className="text-sm text-muted2 leading-relaxed">
          Déjanos cómo contactarte para que <strong>{businessName || "el vendedor"}</strong> pueda confirmarte detalles y enviarte el producto.
        </p>
      </div>

      <label className="block">
        <span className="text-[11px] uppercase tracking-wide text-muted2 font-semibold">Nombre (opcional)</span>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Cómo te llamas"
          className="mt-1 w-full px-3 py-2 text-sm border border-zinc-300 focus:border-klein focus:outline-none"
          data-testid="chat-gate-name"
        />
      </label>

      <label className="block">
        <span className="text-[11px] uppercase tracking-wide text-muted2 font-semibold flex items-center gap-1">
          <WhatsappLogo size={11} weight="fill" className="text-[#25D366]" />
          WhatsApp (requerido)
        </span>
        <input
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="55 1234 5678"
          className="mt-1 w-full px-3 py-2 text-sm border border-zinc-300 focus:border-klein focus:outline-none"
          data-testid="chat-gate-phone"
        />
      </label>

      <label className="block">
        <span className="text-[11px] uppercase tracking-wide text-muted2 font-semibold flex items-center gap-1">
          <EnvelopeSimple size={11} weight="fill" />
          Email (requerido)
        </span>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="tu@email.com"
          className="mt-1 w-full px-3 py-2 text-sm border border-zinc-300 focus:border-klein focus:outline-none"
          data-testid="chat-gate-email"
        />
      </label>

      {gateError && (
        <p className="text-sm text-[#FF2A00]" data-testid="chat-gate-error">
          {gateError}
        </p>
      )}

      <button
        type="submit"
        disabled={gateBusy}
        className="bg-klein hover:bg-klein-dark text-white font-medium text-sm py-2.5 disabled:opacity-60"
        data-testid="chat-gate-submit"
      >
        {gateBusy ? "Iniciando…" : "Guardar y empezar conversación"}
      </button>

      <p className="text-[11px] text-muted2 flex items-center gap-1">
        <ShieldCheck size={11} /> Tu información es privada — sólo el vendedor la usa para responderte.
      </p>
    </form>
  );
}
